import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory, useParams } from "react-router-dom";
import useFlash from "go-alert/AlertMessage";
import Header, { ButtonProps } from "go-app/components/Header";
import { MobileActionProps } from "go-app/components/MobileActions/MobileAction";
import MobileActions from "go-app/components/MobileActions/MobileActions";
import handleError from "go-app/services/errors";
import { useBrowserTabTitle } from "go-core/components/BrowserTab/useBrowserTabTitle";
import { LoadingContainer } from "go-core/components/Loading";
import { useWindowSize } from "go-core/components/useWindowSize";
import { adminApi } from "../../../../../../../../services/Api/Admin/adminApi";
import { UserApi } from "../../../../../../../../services/Api/types";
import UserForm from "../../components/UserForm";

interface MatchParams {
	userId: string;
}

const UserEditPage = () => {
	const [user, setUser] = useState<UserApi | undefined>();
	const history = useHistory();
	const { t } = useTranslation("admin");
	const isMobile = useWindowSize().isMobile;
	const { handleChangeTabTitle } = useBrowserTabTitle();
	const { addFlash } = useFlash();
	const { userId } = useParams<MatchParams>();

	useEffect(() => {
		fetchUser();
	}, []);

	const fetchUser = async () => {
		try {
			const res = await adminApi.getUser(Number(userId));
			setUser(res);
			handleChangeTabTitle(
				`${res?.name || ""} | ${t("common.word.users", { ns: "lib" })} | ${t(
					"lib:go_component.navigation.admin"
				)}`
			);
		} catch (err) {
			handleError.alert(err, addFlash);
		}
	};

	if (!user) {
		return <LoadingContainer />;
	}

	const removeUser = async () => {
		await adminApi.removeUser(user.id, { reason: "" });
		history.push(`/admin/users`);
	};

	const buttons: ButtonProps[] = [
		{
			title: t("common.action.remove", { ns: "lib" }),
			dropdown: true,
			action: removeUser,
		},
	];
	const mobileActions: MobileActionProps[] = [
		{
			title: t("common.action.remove", { ns: "lib" }),
			action: removeUser,
		},
	];

	return (
		<div className="content">
			<MobileActions actions={mobileActions} />
			<Header title={`${t("modules.user.header.edit.title")} ${user.name}`} buttons={isMobile ? [] : buttons} />
			<UserForm user={user} />
		</div>
	);
};

export default UserEditPage;
